/* =================== DEPOIMENTOS =================== */
$(function () {
  const slideItems = $('.carrosel-depoimentos .depoimento-wrp').length;
  const slideDots = slideItems > 1;
  $('.carrosel-depoimentos').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});
